<template>
  <section id="login-verify">
    <div class="lv-body-container">
      <div class="lv-body">
        Verifying Login Credentials
      </div>
      <img src="@shared/assets/img/general/loading.svg" alt="Verifying">
    </div>
  </section>
</template>

<script>
import axios from 'axios';

import {
  readAlphaDomainPool,
  resolveAuthEndpoint,
} from '@shared/lib/general/alphaAuth';

export default {
  name: 'LoginVerifyView',
  mounted() {
    const {
      query,
    } = this.$route;
    if (!query?.code) {
      this.$router.replace('/login');
    } else {
      this.validateCode();
    }
  },
  methods: {
    async validateCode() {
      const {
        query,
      } = this.$route;
      try {
        const pool = readAlphaDomainPool();
        const provider = localStorage.getItem('loginProvider');
        const { baseUrl, clientId, useAlpha } = resolveAuthEndpoint(provider, pool);
        const params = new URLSearchParams();
        params.append('grant_type', 'authorization_code');
        params.append('client_id', clientId);
        params.append('redirect_uri', `${window.location.origin}/login/verify`);
        params.append('code', query.code);
        const { data } = await axios.post(`${baseUrl}/token`, params);
        localStorage.currentUser = JSON.stringify(data);
        await this.exchangeAlphaJwt(data.access_token, useAlpha ? pool : null);
        this.validateUser(data);
      } catch (err) {
        this.handleFallback();
      }
    },
    async exchangeAlphaJwt(jwtToken, pool) {
      const email = localStorage.getItem('loginEmail');
      if (!jwtToken || !email || !pool) {
        localStorage.removeItem('alphaLoginSession');
        return;
      }
      try {
        const { data } = await axios.post(`${process.env.API_URL}/auth/alpha/jwt`, {
          jwtToken,
          email,
          entityType: 'Admin',
        });
        if (data?.loginSessionId) {
          localStorage.setItem('alphaLoginSession', JSON.stringify(data));
        } else {
          localStorage.removeItem('alphaLoginSession');
        }
      } catch (err) {
        console.warn('Alpha JWT exchange failed; CPT session still active', err);
        localStorage.removeItem('alphaLoginSession');
      }
    },
    async validateUser(data) {
      try {
        const res = await this.$store.dispatch('getUserInfo');
        const { accountStatus, id, email } = res;
        if (email.toLowerCase() !== localStorage.getItem('loginEmail')?.toLowerCase()) {
          this.handleFallback("Email address not recognized");
          return;
        }
        if (accountStatus === 'Active' && id) {
          const user = { ...data };
          user.customerId = id;
          user.userId = id;
          localStorage.currentUser = JSON.stringify(user);
          await this.$store.dispatch('getCurrentAdminInfo');
          const {
            redirectUrl,
          } = localStorage;
          if (redirectUrl) {
            this.$router.replace(redirectUrl);
          } else {
            this.$router.replace('/service');
          }
        }
      } catch (err) {
        console.error(err);
        this.handleFallback('No account registered with this email');
      }
    },
    handleFallback(error = '') {
      const {
        query,
      } = this.$route;
      if (query.state && query.state.includes('create-password')) {
        this.$router.replace(`${query.state}?error=${error}`);
      } else {
        this.$router.replace(`/login?error=${error}`);
      }
    },
  },
};
</script>

<style lang="scss">
section#login-verify {
  display: grid;
  height: 100%;
  justify-content: center;
  align-items: center;

  .lv-body-container {
    display: grid;
    justify-items: center;
    background-color: white;
    border-radius: 12px;
    padding: 20px;
  }
}
</style>
